import request from '@/utils/request';

export function getUserGroups(params) {
  return request({
    url: `/user-group?${params}`,
    method: 'get',
    // data: pagination,
  });
}

// export function getUsers(pagination) {
//   return request({
//     url: '/user',
//     method: 'get',
//     data: pagination,
//   });
// }

export function getUsers(params) {
  return request({
    url: `/user?${params}`,
    method: 'get',
  });
}

export function reset2fa(data) {
  return request({
    url: `/user/${data.id}/reset-2fa`,
    method: 'patch',
  });
}

export function resetPassword(data) {
  return request({
    url: `/user/${data.id}/reset-password`,
    method: 'patch',
  });
}

export function getPasswordToken(id) {
  return request({
    url: `/user/${id}/password-token`,
    method: 'get',
  });
}

export function saveUser(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data: data,
  });
}

export function saveUserGroup(data) {
  return request({
    url: '/user-group/save',
    method: 'post',
    data: data,
  });
}

export function deleteUserGroup(id) {
  return request({
    url: `/user-group/${id}`,
    method: 'delete',
  });
}

export function toggleStatus(id) {
  return request({
    url: `/user/${id}/toggle-status`,
    method: 'patch',
  });
}
